import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'open_with_faire-view_application_tier-view';

/**
 * Event for recording when retailer views a specific open with faire application tier type
 */
export function trackOpenWithFaireViewApplicationTierView(
  customParameterToken: string,
  isSignUp_string2: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken, isSignUp_string2 },
  });
}
